export default {
    namespaced: true,

    state: {
        snackbar: {
            show: false,
            color: '',
            text: ''
        }
    },

    getters: {

    },

    mutations: {
        SET_SNACKBAR(state, snackbar) {
            state.snackbar = snackbar
        }
    },

    actions: {
        set_snackbar({ commit }, snackbar) {
            snackbar.show = true
            commit('SET_SNACKBAR', snackbar)
        }
    }
}
